import Layout from "../../components/layout/layout";
import { useNavigate } from "react-router-dom";
import Button from "../../components/library/button";
import NotFound from "../../assets/images/notfound.jpg";
import { ExploreIcon } from "../../assets/images/svgExports";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Layout>
      <section className="flex md:h-[88.25vh]  w-full items-center justify-center  bg-center bg-no-repeat bg-cover">
        <div className="flex flex-col  items-center justify-center z-10 md:py-0 py-24">
          <div className="h-[auto] md:w-[25rem] w-[18rem]">
            <img
              src={NotFound}
              alt="Not found illustration"
              className="w-full fit-cover"
            />
          </div>

          <Button type="button" onClick={() => navigate("/")} className="gap-2">
            Return to homepage <ExploreIcon />
          </Button>
        </div>
      </section>
    </Layout>
  );
}
